var map = {
	"./australia.png": "r/j0",
	"./bangladesh.png": "gew1",
	"./brazil.png": "hhrX",
	"./canada.png": "ldPw",
	"./great-britain.png": "ndys",
	"./italy.png": "eoMo",
	"./mexico.png": "4rF+",
	"./oman.png": "sJyC",
	"./slovakia.png": "+WLx",
	"./south-africa.png": "wGBy",
	"./spain.png": "xMUu",
	"./usa.png": "40jM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0qnN";